import { render, staticRenderFns } from "./EstornarItemPedido.vue?vue&type=template&id=42d08528&scoped=true"
import script from "./EstornarItemPedido.vue?vue&type=script&lang=js"
export * from "./EstornarItemPedido.vue?vue&type=script&lang=js"
import style0 from "./EstornarItemPedido.vue?vue&type=style&index=0&id=42d08528&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d08528",
  null
  
)

export default component.exports